<template>
    <div class="l-row">
        <div class="l-row__column a-tabs">
            <div
                v-if="customerAddressesMainTab"
                class="a-tabs__container"
            >
                <div
                    class="a-tabs__tab"
                    :class="{'a-tabs__tab--active': currentAddress === idx || customerAddresses.length > 3 }"
                    @click="isMobile ? goToAddress(idx) : customerAddresses.length <= 3 ? currentAddress = idx : false"
                    v-for="(address, idx) in customerAddressesMainTab"
                    v-bind:key="idx"
                >
                    <div v-if="address.address">
                        <p
                            class="a-tabs__address"
                            v-html="formatAddress(address.address)"
                        ></p>
                    </div>
                    <div v-else>
                        <p class="a-tabs__address">{{ address.street }} {{ address.number }}</p>
                        <p class="a-tabs__address">{{ address.postcode }} {{ address.city }}</p>
                    </div>
                    <div>
                        <p
                            v-if="!isNaN(weekAmount(customerAddresses.length > 3 ? currentAddressId : idx))"
                            class="a-tabs__price a-price a-price--small"
                        >
                            <span class="a-price__price">{{ weekAmount(customerAddresses.length > 3 ? currentAddressId : idx).toFixed(2).toPLN() }} </span>
                            <span class="a-tabs__priceTime a-price__time">/ 7 dni</span>
                        </p>
                        <p
                            v-if="!isNaN(monthAmount(customerAddresses.length > 3 ? currentAddressId : idx))"
                            class="a-tabs__price a-price a-price--small"
                        >{{ monthAmount(customerAddresses.length > 3 ? currentAddressId : idx).toFixed(2).toPLN() }} <span class="a-tabs__priceTime a-price__time">/ 1 mc</span></p>
                    </div>
                    <div class="a-tabs__tabEdit">
                        <button
                            class="a-button a-tabs__tabEditButton"
                            @click.stop="goToAddress(idx)"
                        >
                            <svg class="a-tabs__tabEditButtonSvg" width="16" height="16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.3 12.4"><path fill-rule="evenodd" clip-rule="evenodd" fill="#fff" d="M12.2 4.4L7.9.1c-.1 0-.2-.1-.3-.1-.2 0-.3.1-.4.1L.1 7.2c0 .1-.1.2-.1.4v4.3c0 .1.1.3.1.4.1.1.2.1.4.1h4.2c.1 0 .3-.1.3-.1l7.1-7.1c.3-.3.3-.6.1-.8zm-7.7 6.9H1V7.7l4.1-4.1 3.5 3.5-4.1 4.2zm4.8-4.8L5.8 3l1.8-1.8 3.5 3.5-1.8 1.8z"></path></svg>
                        </button>
                    </div>
                    <div
                        v-if="customerAddresses.length > 1"
                        class="a-tabs__tabRemove"
                        @click.stop="openModalAddressProduct(customerAddresses.length > 3 ? currentAddressId : idx)"
                    ></div>
                </div>
                <div
                    v-if="customerAddresses.length > 3 && !isMobile"
                    class="a-tabs__tab a-tabs__tab--more"
                >
                    <p class="a-tabs__more">Więcej adresów</p>
                    <div class="a-tabs__moreIcon"></div>
                    <div
                        v-if="customerAddresses.length > 3"
                        class="a-tabs__moreList"
                    >
                        <div
                            v-for="(address, idx) in customerAddresses"
                            v-bind:key="idx"
                            @click="currentAddress = idx"
                        >
                            <div
                                class="a-tabs__moreListItem"
                                v-if="idx !== currentAddress"
                            >
                                <div>
                                    <p class="a-tabs__address">{{ address.street }} {{ address.number }}</p>
                                    <p class="a-tabs__address">{{ address.postcode }} {{ address.city }}</p>
                                </div>
                                <div>
                                    <p
                                        v-if="!isNaN(weekAmount(idx))"
                                        class="a-tabs__price a-price a-price--small"
                                    ><span class="a-price__price">{{ weekAmount(idx).toFixed(2).toPLN() }}</span> <span class="a-tabs__priceTime a-price__time">/ 7 dni</span></p>
                                    <p
                                        v-if="!isNaN(weekAmount(idx))"
                                        class="a-tabs__price a-price a-price--small"
                                    >{{ monthAmount(idx).toFixed(2).toPLN() }} <span class="a-tabs__priceTime a-price__time">/ 1 mc</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <o-modal name="addressRemove">
                    <template slot="content" slot-scope="props">
                        Czy usunąć poniższy adres?<br /><br />
                        <strong>
                            {{ props.payload.address.street }} {{ props.payload.address.number }}<br />
                            {{ props.payload.address.postcode }} {{ props.payload.address.city }}
                        </strong>
                        <div class="o-modal__contentButtons">
                            <a-button
                                @click="$store.dispatch('modalHide')"
                            >Nie</a-button>
                            <a-button
                                class="a-button--primary"
                                @click="removeAddress(props.payload.id)"
                            >Tak</a-button>
                        </div>
                    </template>
                </o-modal>
                <div
                    v-if="canAddNewAddress"
                    class="a-tabs__tab a-tabs__tab--button a-tabs__tab--hasTooltip"
                    @click="addNewAddress"
                >
                    <p
                        class="a-tabs__buttonText"
                        :class="{'a-tabs__buttonText--hidden': customerAddresses.length !== 1}"
                    >Dodaj kolejny adres</p>
                    <a-icon icon="Add" />
                </div>
                <p class="a-tabs__buttonTextTooltip">Możesz złożyć jedno zamówienie do wielu adresów. Kliknij aby dodać kolejny adres.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        currentAddress: {
            get() {
                return this.$store.getters.currentAddressId
            },
            set(currentAddress) {
                this.$store.dispatch('setCurrentAddress', currentAddress)
            }
        },
        customerAddressesMainTab() {
            const adresses = this.$store.getters.customerAddresses
            return adresses.length > 3 && !this.isMobile ? adresses.slice(this.currentAddress, this.currentAddress + 1) : adresses
        },
        customerAddresses() {
            return this.$store.getters.customerAddresses
        },
        currentAddressId() {
            return this.$store.getters.currentAddressId
        },
        maxAdressesAmount() {
            return this.$store.getters.customerAddresses.length > 3 ? 1 : 3
        },
        isMobile() {
            return window.innerWidth <= 1024
        },
        canAddNewAddress () {
            return this.$store.getters['companies/oneInvoiceAddress']
        },
        addressesStatus () {
            return this.$store.getters['companies/addressesStatus']
        }
    },
    methods: {
        weekAmount(addressId) {
            return this.$store.getters.weekAmount(addressId)
        },
        monthAmount(addressId) {
            return (this.$store.getters.weekAmount(addressId) * 4)
        },
        goToAddress(id) {
            this.$store.dispatch('setCurrentAddress', id)
            this.$router.push({ name: 'cart-mobile-week', params: { address: id } })
        },
        addNewAddress() {
            this.$router.push({ name: 'delivery-address-add' })
        },
        removeAddress(addressId) {
            this.$store.dispatch('removeAddress', addressId)
            this.$store.dispatch('modalHide')
        },
        openModalAddressProduct(addressId) {
            this.$store.dispatch('modalShow', {
                name: 'addressRemove',
                payload: {
                    id: addressId,
                    address: this.customerAddresses[addressId]
                }
            })
        },
        formatAddress(address) {
            return address.replace(', ', '<br />')
        }
    },
    created() {
        if(this.addressesStatus === 'initial') {
            this.$store.dispatch('companies/fetchAddresses')
        }
    }
}
</script>
